const webhookDashboardState = {
  isLoadingConfigs: {},
  webhooks: {},
  webhooksHeaders: [],
  webhooksHmacSecret: '',
};

export default webhookDashboardState;
